<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.acName" style="width: 140px;" size="small" placeholder="请输入名称"
                        clearable></el-input>
                    <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="info" size="small" icon="el-icon-search" @click="SerchMore"
                        style="margin-left: 10px">更多搜索</el-button>
                    <el-button type="primary" size="small" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button>
                    <el-dropdown size="small" split-button type="warning" style="margin-right: 10px;" :split-button="true"
                        @click="Out()" @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="danger" size="small"
                        @click="BulkDelete">批量删除</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增易耗品</el-button>
                    <el-button type="primary" size="small" style="margin-right: 20px" @click="outAndIn">出入库记录</el-button>

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="acId"
                        style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
                        :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑易耗品' : '新增易耗品'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="易耗品名称" prop="acName">
                                <el-input v-model="form.acName" style="width: 50%;" placeholder="请输入名称"></el-input>
                            </el-form-item>
                            <el-form-item label="配件分类" prop="afcId">
                                <el-select v-model="form.afcId" placeholder="请选择分类">
                                    <el-option v-for="item in afcTypearr || []" :label="item.afcName" :value="item.afcId"
                                        :key="item.afcId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="资产产商" prop="amId">
                                <el-select v-model="form.amId" placeholder="请选择分类">
                                    <el-option v-for="item in amTypearr || []" :label="item.amName" :value="item.amId"
                                        :key="item.amId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="归属地" prop="acAddress">
                                <el-input v-model="form.acAddress" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="图片" prop="acFiles">
                                <my-upload ref="Imgupload" @fileChange="fileChange" :filearr.sync="fileList"
                                    @removeAfter="removeAfter" :limit="limit" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                           
                            <el-form-item label="拥有方式" prop="acOwnerType">
                                <el-select v-model="form.acOwnerType" clearable @change="form.acMoneyBuy = '',
                                    form.acMoneyHireMonth = '', form.acMoneyHireYear = '', form.acMoneyHireManner = ''"
                                    placeholder="请选择" style="width: 130px">
                                    <el-option label="租用" value="租用" key="1"></el-option>
                                    <el-option label="自购" value="自购" key="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="采购单价" prop="acMoneyBuy" v-if="form.acOwnerType == '自购'">
                                <el-input v-model="form.acMoneyBuy" style="width: 80%;" placeholder="请输入"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="租用方式" prop="acMoneyHireManner"  v-if="form.acOwnerType == '租用'">
                                <el-select v-model="form.acMoneyHireManner" clearable @change="
                                    form.acMoneyHireMonth = '', $forceUpdate()" placeholder="请选择"
                                    style="width: 130px">
                                    <el-option label="月租" value="月租" key="1"></el-option>
                                    <el-option label="年租" value="年租" key="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="月租单价" prop="acMoneyHireMonth" v-if="form.acMoneyHireManner && form.acOwnerType == '租用'">
                                <el-input v-model="form.acMoneyHireMonth" style="width: 80%;" placeholder="请输入"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                         

                            <el-form-item label="备注" prop="acDes">
                                <el-input v-model="form.acDes" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="库存报警数量" prop="acStockWarning">
                                <el-input v-model="form.acStockWarning" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 筛选 -->
            <el-dialog title="更多搜索" :visible.sync="IsSerch" width="70%" top="8vh" :close-on-click-modal="false">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formDatas" :model="formDatas" label-position="left" label-width="150px"
                            @submit.native.prevent>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="易耗品名称">
                                    <el-input v-model="formDatas.acName" style="width: 80%;" placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="配件分类">
                                    <el-select v-model="formDatas.afcId" placeholder="请选择分类">
                                        <el-option v-for="item in afcTypearr || []" :label="item.afcName"
                                            :value="item.afcId" :key="item.afcId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                            </div>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="资产产商">
                                    <el-select v-model="formDatas.amId" placeholder="请选择分类">
                                        <el-option v-for="item in amTypearr || []" :label="item.amName" :value="item.amId"
                                            :key="item.amId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="拥有方式">
                                    <el-select v-model="formDatas.acOwnerType" clearable placeholder="请选择"
                                        style="width: 130px">
                                        <el-option label="租用" value="租用" key="1"></el-option>
                                        <el-option label="自购" value="自购" key="2"></el-option>
                                    </el-select>
                                </el-form-item>

                            </div>
                            <el-form-item label="归属地">
                                <el-input v-model="formDatas.acAddress" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="partserch(), IsSerch = false"
                                    style="margin-left: 100px;">立即搜索</el-button>
                                <el-button @click="closeSizer()" style="margin-left: 200px">取消</el-button>
                            </el-form-item>
                        </el-form>

                    </div>
                </div>
            </el-dialog>
            <!-- 入库 -->
            <el-dialog :title="formRk.name + '[入库]'" :visible.sync="ISRk" width="70%" top="8vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formRk" :model="formRk" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="入库数量" prop="acStock">
                                <el-input v-model.number="formRk.acStock" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="购入日期" prop="acrDateBuy">
                                <el-date-picker v-model="formRk.acrDateBuy" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="过保日期" prop="acrDateWarranty">
                                <el-date-picker v-model="formRk.acrDateWarranty" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="备注" prop="acrDes">
                                <el-input v-model="formRk.acrDes" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="CloseRk">取 消</el-button>
                            <el-button type="primary" @click="sureRk">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>
            <!-- 借出 -->
            <el-dialog :title="formBw.name + '[领用]'" :visible.sync="ISborrow" width="70%" top="8vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formBw" :model="formBw" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="员工" prop="auId">
                                <el-select v-model="formBw.auId" filterable placeholder="请选择">
                                    <el-option v-for="item in userArr || []" :label="item.auName" :value="item.auId"
                                        :key="item.auId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="数量" prop="aubrThisNum">
                                <el-input v-model.number="formBw.aubrThisNum" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="计划归还日期" prop="aubrReturnPlanDate">
                                <el-date-picker v-model="formBw.aubrReturnPlanDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="领用日期" prop="aubrBorrowDate">
                                <el-date-picker v-model="formBw.aubrBorrowDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="备注" prop="aubrThisDes">
                                <el-input v-model="formBw.aubrThisDes" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="CloseBorrow">取 消</el-button>
                            <el-button type="primary" @click="sureBorrow">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>
            <!-- 出入库记录 -->
            <el-dialog title="出入库记录" :visible.sync="InRk" width="70%" top="8vh" :before-close="handleClose2">
                <div style="width: 95%;margin: 15px auto;">
                    <div style="width: 100%">
                        <ve-table ref="rktable" v-if="Rkdata" :columns="columns2" :table-data="Rkdata" :max-height="600"
                            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            :cellSelectionOption="cellSelectionOption" style="width: 100%" />
                        <div v-show="Rkdata.length == 0" class="empty-data">暂无数据</div>
                    </div>
                    <div class="table-pagination">
                        <ve-pagination :total="totalCount2" :page-index="formDatas2.currentPage"
                            :page-size="formDatas2.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                            @on-page-number-change="pageNumberChange2" @on-page-size-change="pageSizeChange2" />
                    </div>
                </div>
            </el-dialog>
              <!-- 批量导入 -->
              <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/assets/excel/consumables.xlsx', '易耗品模板')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div style="margin: 10px;font-size: 18px;" v-if="bulkData.length != 0">
                    <span style="color: #0080FF;">一共{{ importData.numAll }}条;</span>
                    <span style="color: #0E9A00;margin-left: 5px;">成功{{ importData.numSuccess }}条;</span>
                    <span style="color: red;margin-left: 5px;">失败{{ importData.numFail }}条</span>
                    <span style="color: #E6A23C;margin-left: 5px;">信息不完整{{ importData.numUnWhole }}条</span>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
                    <el-button type="success" @click="bulkImportClick">确定导入</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
  
<script>

import {
    getAjConsumablesList, addAjConsumables, updateAjConsumables, deleteAjConsumables, getAjConsumablesRecordList,
    getAjFittingsClassList, getAjManufacturerList, updateAjConsumablesStock, getAjUserList, addAjUserBorrow,
    uploadAjAjConsumables,exportAjConsumables,uploadImportAjConsumables
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            sitId: '',
            TemstrongArr: [],
            importData: {},
            bulkData: [],
            bulkDataCopy: [],
            bulkImport: false,
            columnsImport: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "status",
                    key: "status",
                    title: "状态",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                    filter: {
                        filterList: [
                            { value: 0, label: '成功', selected: false },
                            { value: 1, label: '失败', selected: false },
                            { value: 3, label: '信息不完整', selected: false }
                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            this.searchByNameField(labels, 'status');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameField([]);
                        },
                        // max height
                        maxHeight: 120,
                    },
                },
                {
                    field: "statusMsg",
                    key: "statusMsg",
                    title: "状态备注",
                    width: 150,
                    align: "center",


                },
                {
                    field: "acName",
                    key: "acName",
                    title: "易耗品名称",
                    width: 100,
                    align: "center",
                  
                      
                },
                {
                    field: "afcName",
                    key: "afcName",
                    title: "配件分类",
                    align: "center",

                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "amName",
                    key: "amName",
                    title: "资产厂商",
                    align: "center",
                    //   
                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "acAddress",
                    key: "acAddress",
                    title: "归属地",
                    align: "center",
                    //   
                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "acOwnerType",
                    key: "acOwnerType",
                    title: "拥有方式",
                    align: "center",
                    width: 120,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "acStockLend",
                    key: "acStockLend",
                    title: "借出数量",
                    align: "center",
                    width: 120,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "acStock",
                    key: "acStock",
                    title: "库存数量",
                    align: "center",
                    width: 120,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },

                {
                    field: "acStockWarning",
                    key: "acStockWarning",
                    title: "库存报警数量",
                    align: "center",
                      
                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "acFiles",
                    key: "acFiles",
                    title: "图片",
                    align: "center",
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acFiles ? <el-image ref="scrImg" id="scrimg" src={row.acFiles.split(',')[0]} alt="" fit="fill" style="width: 100%;height: 50px;"
                                        previewSrcList={row.acFiles.split(',')}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },
                },
                {
                    field: "acDes",
                    key: "acDes",
                    title: "备注",
                    align: "center",
                      
                    width: 120,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },



            ], //表格的列

            totalCount2: 0,
            key: 'acId',
            InRk: false,
            Rkdata: [],
            formRk: {

            },
            ISRk: false,
            fileList: [],
            limit: 6,
            userArr: [],
            formBw: {

            },
            ISborrow: false,

            afcTypearr: [],
            amTypearr: [],
            dialog: false,
            IsSerch: false,
            edit: false,
            form: {
                acName: '',
                acFiles: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acName",
                    key: "acName",
                    title: "易耗品名称",
                    width: 100,
                    align: "center",
                    fixed: 'left',
                    edit: true,
                },
                {
                    field: "acAddress",
                    key: "acAddress",
                    title: "归属地",
                    align: "center",
                    fixed: 'left',
                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "afcName",
                    key: "afcName",
                    title: "配件分类",
                    align: "center",

                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "amName",
                    key: "amName",
                    title: "资产厂商",
                    align: "center",
                    // edit: true,
                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                
                {
                    field: "acOwnerType",
                    key: "acOwnerType",
                    title: "拥有方式",
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "acMoneyBuy",
                    key: "acMoneyBuy",
                    title: "采购单价",
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "acMoneyHireManner",
                    key: "acMoneyHireManner",
                    title: "租用方式",
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "acMoneyHireMonth",
                    key: "acMoneyHireMonth",
                    title: "月租单价",
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "acMoneyHireYear",
                    key: "acMoneyHireYear",
                    title: "年租单价",
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "acStockLend",
                    key: "acStockLend",
                    title: "借出数量",
                    align: "center",
                    width: 120,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "acStock",
                    key: "acStock",
                    title: "库存数量",
                    align: "center",
                    width: 120,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },

                {
                    field: "acStockWarning",
                    key: "acStockWarning",
                    title: "库存报警数量",
                    align: "center",
                    edit: true,
                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "acFiles",
                    key: "acFiles",
                    title: "图片",
                    align: "center",
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acFiles ? <el-image ref="scrImg" id="scrimg" src={row.acFiles.split(',')[0]} alt="" fit="fill" style="width: 100%;height: 50px;"
                                        previewSrcList={row.acFiles.split(',')}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },
                },
                 {
                    field: "auName",
                    key: "auName",
                    title: "当前使用人",
                    align: "center",
                    // edit: true,
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "部门",
                    align: "center",
                    // edit: true,
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                // {
                //     field: "auBelong",
                //     key: "auBelong",
                //     title: "归属",
                //     align: "center",
                //     // edit: true,
                //     width: 150,
                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },
                {
                    field: "acDes",
                    key: "acDes",
                    title: "备注",
                    align: "center",
                    edit: true,
                    width: 120,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 250,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.addRk(row)}
                                >
                                    入库
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: #67C23A"
                                    on-click={() => this.addBorrow(row)}
                                >
                                    领用
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.getRkone(row)}
                                >
                                    出入库记录
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            columns2: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acName",
                    key: "acName",
                    title: "易耗品名称",
                    width: 100,
                    align: "center",
                    fixed: 'left',

                },
                {
                    field: "acStock",
                    key: "acStock",
                    title: "库存数量",
                    width: 100,
                    align: "center",

                },
                {
                    field: "acrNum",
                    key: "acrNum",
                    title: "改变",
                    width: 100,
                    align: "center",


                },
                {
                    field: "acrThisName",
                    key: "acrThisName",
                    title: "领用人",
                    width: 100,
                    align: "center",


                },
                {
                    field: "acrDateBuy",
                    key: "acrDateBuy",
                    title: "购入时间",
                    width: 100,
                    align: "center",


                },
                {
                    field: "acrDateWarranty",
                    key: "acrDateWarranty",
                    title: "过保时间",
                    width: 100,
                    align: "center",


                },
                {
                    field: "",
                    key: "aa",
                    title: "方式",
                    width: 100,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acrThisName ? <el-tag>出库</el-tag> : <el-tag>入库</el-tag>
                                }


                            </span>
                        );
                    },

                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "创建时间",
                    width: 150,
                    align: "center",


                },
            ],
            tableData: [],
            post: null,
            formDatas: {
                acName: "",
                afcId: "",
                amId: "",
                acOwnerType: "",
                dmDelete: 1,
                currentPage: 1,
                pageSize: 20,
            },
            formDatas2: {
                acrThisId: "",
                acId: "",
                acrType: "",
                acOwnerType: "",
                dmDelete: 1,
                currentPage: 1,
                pageSize: 20,
            },
        };
    },
    activated() {
        getAjUserList({checkStatus:2}).then(res => {
            this.userArr = res.data
        })
        getAjManufacturerList().then(res => {
            this.amTypearr = res.data
        })
        getAjFittingsClassList().then(res => {
            this.afcTypearr = res.data
        })
        this.getList();
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {

        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;

    },
    mounted() {


    },
    methods: {
          // 批量删除
          BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjConsumables({ acIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },

        Out(command) {
            console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                exportAjConsumables({ acIds: this.selectedRowKeysCollection.toString() }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });
                        this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = []

                    }
                })
            } else {
                this.openLoading()
                exportAjConsumables({ exportType: 1 }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            }
        },


        searchByNameField(labels, id) {
            this.bulkData = this.bulkDataCopy.filter(
                (x) => labels.length === 0 || labels.includes(x[id]),
            );
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                this.openLoading()
                uploadImportAjConsumables({
                    sitId: this.sitId
                }).then(res => {
                    this.loadings.close()
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()

                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {

            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAjConsumables(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];

                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },

        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },

        removeAfter(file) {
            const url = this.form.afFiles.findIndex(item => item === file)
            this.form.acFiles.splice(url, 1)
        },
        getRkone(row) {
            this.formDatas2.acId = row.acId;
            getAjConsumablesRecordList(this.formDatas2).then(res => {
                this.Rkdata = res.data;
                this.totalCount2 = res.total;
                this.InRk = true;
            })
        },

        outAndIn() {
            getAjConsumablesRecordList().then(res => {
                this.Rkdata = res.data;
                this.totalCount2 = res.total;
                this.InRk = true;
            })

        },
        // 入库
        addRk(val) {
            this.$nextTick(() => {
                this.formRk.acId = val.acId;
                this.formRk.name = val.acName;
            })
            this.ISRk = true;
        },
        sureRk() {
            this.$confirm("是否确定要入库吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjConsumablesStock(this.formRk).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "入库成功!",
                            });
                            this.CloseRk()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        CloseRk() {
            this.ISRk = false;
            this.$refs['formRk'].resetFields();
        },

        // 上传图片
        fileChange(file) {
            if (this.form.acFiles.length > 0 && this.form.acFiles) {
                this.form.acFiles.push(...file)
            } else {
                this.$set(this.form, 'acFiles', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },

        addBorrow(val) {
            this.$nextTick(() => {
                this.formBw.aubrThisId = val.acId;
                this.formBw.aubrType = 3;
                this.formBw.aubrBorrowReturn = 1;
                this.formBw.name = val.acName;
            })

            this.ISborrow = true;
        },
        sureBorrow() {
            this.$confirm("是否确定要出借吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    addAjUserBorrow(this.formBw).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "出借成功!",
                            });
                            this.CloseBorrow()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        CloseBorrow() {
            this.ISborrow = false;

            this.$refs['formBw'].resetFields();
        },

        closeSizer() {
            this.formDatas = {
                acName: "",
                afcId: "",
                amId: "",
                acOwnerType: "",
                dmDelete: 1,
                currentPage: 1,
                pageSize: 20,
            };
            this.IsSerch = false;
            this.partserch()
        },
        SerchMore() {
            this.IsSerch = true;
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjConsumables({ acIds: row.acId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.acFiles =data.acFiles? data.acFiles.split(','): [];
                console.log(this.form.acFiles);
                if (data.acFiles.length > 0) {
                    this.form.acFiles.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })

                }

            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.form.acFiles = this.form.acFiles.toString()
                        addAjConsumables(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.form.acFiles = this.form.acFiles.toString()
                        updateAjConsumables(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$nextTick(() => {
                this.fileList = []
                this.$refs['formRef'].resetFields();
            })
        },
        handleClose2() {
            this.InRk = false;
            this.Rkdata = [];
            this.getList()
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.acId = row.acId
                    console.log(jsonObj);
                    updateAjConsumables(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {
            console.log(row);
            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjConsumablesList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });

        },
        pageSizeChange2(pageSize) {

            this.formDatas2.pageSize = pageSize;
            getAjConsumablesRecordList(this.formDatas2).then((res) => {
                this.Rkdata = res.data;
                this.totalCount2 = res.total;
                // this.resetSelectedRowKeys(this.key);
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });


        },
        pageNumberChange2(pageIndex) {
            console.log(pageIndex);
            this.formDatas2.currentPage = pageIndex;
            getAjConsumablesRecordList(this.formDatas2).then((res) => {
                this.Rkdata = res.data;
                this.totalCount2 = res.total;
                // this.resetSelectedRowKeys(this.key);
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjConsumablesList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjConsumablesList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>
  
<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
  